import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateVisualLanguageArgs,
  BackendVisualLanguage,
} from 'src/types/backend';

import { FRAGMENT_VISUAL_LANGUAGE } from './schema';

const MUTATION = gql`
  mutation UpdateVisualLanguage($id: ID!, $name: String!) {
    updateVisualLanguage(id: $id, name: $name) {
      ...VisualLanguage
    }
  }
  ${FRAGMENT_VISUAL_LANGUAGE}
`;

type Variables = BackendMutationUpdateVisualLanguageArgs;
type Result = BackendVisualLanguage;

export const updateVisualLanguage = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
